import mobileLogo from 'assets/images/logo-sm.svg'

import logo from '../assets/images/logo.svg'

const LOGO = {
  MOBILE: mobileLogo,
  DESKTOP: logo
}

export default LOGO
